<template>
  <div class="renew-shell">
    <div class="renew-card">
      <div class="eyebrow">Renewal Required</div>
      <h1>Annual license renewal is required.</h1>
      <p>
        This workspace has reached the end of its annual license grace period.
        Billing remains available so you can complete renewal and restore access.
      </p>

      <div class="meta-row">
        <div class="meta-chip">
          <span>Status</span>
          <strong>{{ access.status || "locked" }}</strong>
        </div>
        <div v-if="access.licenseExpiresAt" class="meta-chip">
          <span>Expired</span>
          <strong>{{ formatDate(access.licenseExpiresAt) }}</strong>
        </div>
        <div v-if="access.gracePeriodEndsAt" class="meta-chip">
          <span>Grace Ended</span>
          <strong>{{ formatDate(access.gracePeriodEndsAt) }}</strong>
        </div>
      </div>

      <div class="actions">
        <router-link class="btn btn-dark" to="/billing">Open Billing</router-link>
        <router-link class="btn btn-outline-secondary" to="/">Sign Out</router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useAccessStore } from "@/stores/accessStore";

const access = useAccessStore();

function formatDate(value) {
  return new Date(value).toLocaleDateString("en-KE", { dateStyle: "medium" });
}
</script>

<style scoped>
.renew-shell {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    radial-gradient(circle at top left, rgba(245,158,11,.10), transparent 28%),
    radial-gradient(circle at bottom right, rgba(15,23,42,.10), transparent 32%),
    #f8fafc;
}
.renew-card {
  width: 100%;
  max-width: 820px;
  background: #fff;
  padding: 40px;
  border-radius: 28px;
  box-shadow: 0 24px 80px rgba(15, 23, 42, 0.14);
}
.eyebrow {
  font-size: 12px;
  letter-spacing: .16em;
  text-transform: uppercase;
  color: #64748b;
  font-weight: 700;
  margin-bottom: 12px;
}
h1 {
  margin: 0 0 14px;
  font-size: 38px;
  line-height: 1.05;
}
p {
  margin: 0;
  line-height: 1.8;
  color: #475569;
}
.meta-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 24px;
}
.meta-chip {
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 14px;
  border-radius: 18px;
  background: #f8fafc;
  border: 1px solid rgba(148, 163, 184, 0.2);
}
.meta-chip span {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: .12em;
  color: #64748b;
}
.meta-chip strong {
  color: #0f172a;
}
.actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 28px;
}
</style>
